import React, {useEffect, useRef, useState} from "react";
import {connect} from "react-redux";

// import moment from 'moment';
import 'moment/locale/pl'

import {
    Row,
    Col,
    Card,
    CardBody,
} from 'reactstrap'

import {
    setStartDate, setEndDate,
} from "actions";

const IndicatorDescription = ({PlotData: {active_plot}, Indicators: {available_indicators, active_indicators}}) => {
    const [description, setDescription] = useState(null)
    useEffect(() => {
        if(available_indicators) {
            const indicator = available_indicators.filter(available => available.nazwa === active_plot)[0]
            if (indicator) {
                setDescription(indicator.opis)
            }
        }
    }, [active_plot])

    return (
         <Card>
            <CardBody className="text-justify">
                {description !=="" ? description : "Brak dostępnego opisu"}
            </CardBody>
        </Card>
    )
}

// export default IndicatorList
const mapStateToProps = state => ({
    PlotData: state.PlotData,
    Indicators: state.Indicators
});

export default connect(mapStateToProps, {
    setStartDate,
    setEndDate,
})(IndicatorDescription)
